const elements = require('./elements');
const themes = require('./themes');
const channels = require('./channels');

/**
 * Generate the different combinations for each set of elements
 *
 * @param {string} theme
 *
 * @returns {array}
 */
const createCombinations = (theme) => {
  return Object.entries(elements)
    .filter(([, elementData]) => {
      return elementData.availableInThemes.includes(theme);
    })
    .map(([elementId]) => {
      return elementId;
    });
};

// @TODO This really could be cleaned up, and all the port numbers moved to the elements config files.. I don't think theres
// any need to have them defined here like this, except to maybe create the combinations down below. The following could
// still be dynamically generated, except rather then defining a port number in here, we simply read it from element config
// Might make it tricky to add new elements thought..
const portsByElement = {
  // [elements.BLOSSOMS_A.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.BLOSSOMS_B.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.SANTA_REINDEER.id]: { [channels.CONST__CH_1]: [85, 87], [channels.CONST__CH_2]: [88, 89] },
  [elements.SANTA_SLEIGH.id]: { [channels.CONST__CH_1]: 87, [channels.CONST__CH_2]: null },
  [elements.SANTA_HAND.id]: { [channels.CONST__CH_1]: 85, [channels.CONST__CH_2]: 86 },
  [elements.REINDEER_SLEIGH.id]: { [channels.CONST__CH_1]: 88, [channels.CONST__CH_2]: null },
  [elements.REINDEER_LEGS.id]: { [channels.CONST__CH_1]: 89, [channels.CONST__CH_2]: 90 },
  // [elements.HOLLY.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.SNOWFLAKE_ICE_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.SNOWFLAKE_ICE_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.SNOWFLAKE_WARM.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.KANGAROO_A.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.KANGAROO_B.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  [elements.KOALA.id]: { [channels.CONST__CH_1]: 73, [channels.CONST__CH_2]: 74 },
  [elements.ROPELIGHT_W.id]: { [channels.CONST__CH_1]: 75, [channels.CONST__CH_2]: 76 },

  [elements.REINDEER_BUCKY_CW.id]: { [channels.CONST__CH_1]: 207, [channels.CONST__CH_2]: 208 },
  [elements.REINDEER_BUCKY_WW.id]: { [channels.CONST__CH_1]: 205, [channels.CONST__CH_2]: 206 },
  [elements.REINDEER_BUCKY_MULTI.id]: { [channels.CONST__CH_1]: 209, [channels.CONST__CH_2]: 210 },
  [elements.REINDEER_JO_CW.id]: { [channels.CONST__CH_1]: 211, [channels.CONST__CH_2]: 212 },
  [elements.REINDEER_JO_WW.id]: { [channels.CONST__CH_1]: 215, [channels.CONST__CH_2]: 216 },
  [elements.REINDEER_JO_MULTI.id]: { [channels.CONST__CH_1]: 213, [channels.CONST__CH_2]: 214 },
  [elements.REINDEER_JANE_CW.id]: { [channels.CONST__CH_1]: 223, [channels.CONST__CH_2]: 224 },
  [elements.REINDEER_JANE_WW.id]: { [channels.CONST__CH_1]: 227, [channels.CONST__CH_2]: 228 },
  [elements.REINDEER_JANE_MULTI.id]: { [channels.CONST__CH_1]: 225, [channels.CONST__CH_2]: 226 },

  [elements.FENCE_WARM_WHITE.id]: { [channels.CONST__CH_1]: 219, [channels.CONST__CH_2]: 220 },
  [elements.FENCE_COOL_WHITE.id]: { [channels.CONST__CH_1]: 221, [channels.CONST__CH_2]: 222 },
  [elements.FENCE_MULTI.id]: { [channels.CONST__CH_1]: 218, [channels.CONST__CH_2]: 217 },

  [elements.PEPPERMINT_TREES.id]: { [channels.CONST__CH_1]: 100, [channels.CONST__CH_2]: 99 },
  [elements.ELF_TREE_1.id]: { [channels.CONST__CH_1]: 182, [channels.CONST__CH_2]: 181 },
  [elements.ELF_TREE_2.id]: { [channels.CONST__CH_1]: 98, [channels.CONST__CH_2]: 97 },
  // [elements.LETTERBOX.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.LETTERBOX_TREES_COOL_WHITE.id]: { [channels.CONST__CH_1]: 41, [channels.CONST__CH_2]: 42 },
  [elements.LETTERBOX_TREES_WARM_WHITE.id]: { [channels.CONST__CH_1]: 37, [channels.CONST__CH_2]: 38 },
  [elements.LETTERBOX_TREES_MULTI.id]: { [channels.CONST__CH_1]: 39, [channels.CONST__CH_2]: 40 },

  [elements.TREE_WARM_WHITE.id]: { [channels.CONST__CH_1]: 1, [channels.CONST__CH_2]: 2 },
  [elements.TREE_MULTI.id]: { [channels.CONST__CH_1]: 4, [channels.CONST__CH_2]: 3 },
  [elements.TREE_COOL_WHITE.id]: { [channels.CONST__CH_1]: 5, [channels.CONST__CH_2]: 6 },

  [elements.MEGA_TREE_WARM_WHITE.id]: { [channels.CONST__CH_1]: 197, [channels.CONST__CH_2]: 198 },
  [elements.MEGA_TREE_COOL_WHITE.id]: { [channels.CONST__CH_1]: 193, [channels.CONST__CH_2]: 194 },
  [elements.MEGA_TREE_MULTI.id]: { [channels.CONST__CH_1]: 195, [channels.CONST__CH_2]: 196 },

  [elements.MEGA_TREE_STAR_MULTI.id]: { [channels.CONST__CH_1]: 188, [channels.CONST__CH_2]: 187 },
  [elements.MEGA_TREE_STAR_WARM.id]: { [channels.CONST__CH_1]: 185, [channels.CONST__CH_2]: 186 },
  [elements.MEGA_TREE_STAR_COOL.id]: { [channels.CONST__CH_1]: 183, [channels.CONST__CH_2]: 184 },

  // [elements.ROOF_MOUNTAIN_WARM_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.ROOF_MOUNTAIN_COOL.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.ROOF_MOUNTAIN_WARM_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.GUTTER_LINE_WARM.id]: { [channels.CONST__CH_1]: 15, [channels.CONST__CH_2]: 16 },
  [elements.GUTTER_LINE_COOL.id]: { [channels.CONST__CH_1]: 17, [channels.CONST__CH_2]: 18 },
  [elements.GUTTER_LINE_MULTI.id]: { [channels.CONST__CH_1]: 14, [channels.CONST__CH_2]: 13 },

  [elements.SANTA.id]: { [channels.CONST__CH_1]: 55, [channels.CONST__CH_2]: 56 },
  [elements.TRAIN.id]: { [channels.CONST__CH_1]: 59, [channels.CONST__CH_2]: 60 },
  [elements.MERRY_CHRISTMAS_SIGN.id]: { [channels.CONST__CH_1]: 57, [channels.CONST__CH_2]: 58 },

  [elements.RIBBON_BELLS.id]: { [channels.CONST__CH_1]: 127, [channels.CONST__CH_2]: 128 },
  [elements.BELLS.id]: { [channels.CONST__CH_1]: 129, [channels.CONST__CH_2]: 130 }

  // [elements.ROOF_OUTLINE_WARM.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.ROOF_OUTLINE_COOL.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.ROOF_OUTLINE_MULTI.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  // [elements.MINI_TREES_WW_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_W_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_WW_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_W_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_WW_3.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_W_3.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_WW_4.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null }
};

// Using the hardcoded channel and element values above, swap the keys/values, such that the channel ID is the key, and
// the element ID is the value
/**
 * @var {{
 *    portId: {
 *      elementId,
 *      channel
 *    }
 *  }} elementsByPort
 * `portId` is the output port number for the controller
 * `elementId` is the string identifier for the element
 * `channel` is the first or second channel for the above element
 */
const elementsByPort = {};
const portsSeen = [];
Object.entries(portsByElement).forEach(([elementId, channels]) => {
  Object.entries(channels).forEach(([channel, port]) => {
    if (portsSeen.includes(port)) {
      // @TODO Come up with a better way to handle where there are ports re-used, and they're expected to be re-used
      console.warn(`Port ${port} used more than once`);
      // throw new Error(`Ports must only be referenced once. Port ${port} used more than once`);
    }
    if (port === 0) {
      throw new Error(`Port 0 needs to be replaced with the actual port number for ${elementId}`);
    }
    if (port !== null) {
      portsSeen.push(port);
    }
    // For elements that are spread out across the yard, they need to be connected to multiple ports, which means
    // in the data above, that element will have an array for the port numbers that is associated.
    // This will mainly in the House component for testing the lights.
    const portNumber = Array.isArray(port) ? port[0] : port;
    elementsByPort[portNumber] = {
      elementId,
      channel: Number.parseInt(channel, 10)
    };

    // If there are two ports, then make sure the other one gets set too.
    // I'm not sure if I'm actually using this anywhere but in the House component at the moment, and this likely
    // means that there will be 2 elements displayed in the House component, but I think that's an issue I should "fix"
    // in the House component itself, rather than messing with the data..
    if (Array.isArray(port)) {
      elementsByPort[port[1]] = {
        elementId,
        channel: Number.parseInt(channel, 10)
      };
    }
  });
});

module.exports = {
  byElement: portsByElement,
  byPort: elementsByPort,

  combinations: [
    // createCombinations(themes.ICE),
    // createCombinations(themes.CLASSIC),
    // createCombinations(themes.PARTY),
    createCombinations(themes.MODERN),
    createCombinations(themes.CHIC),
    createCombinations(themes.ODDBALL),
    createCombinations(themes.CRAZY)
  ]
};
